import { Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { from, map, Observable, throwError } from 'rxjs';

/**
 * Each translation file is built into its own content-hashed chunk, so a deploy that changes a
 * translation also changes its URL. Fetching `assets/i18n/<lang>.json` over HTTP kept one URL across
 * deploys, and server.ts caches static files for a year, so browsers kept showing old text.
 */
const TRANSLATION_FILES: Record<string, () => Promise<{ default: TranslationObject }>> = {
    'en-US': () => import('../../../assets/i18n/en-US.json'),
    'zh-CN': () => import('../../../assets/i18n/zh-CN.json'),
};

@Injectable()
export class BundledTranslateLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<TranslationObject> {
        const loadFile = TRANSLATION_FILES[lang];
        if (!loadFile) {
            return throwError(() => new Error(`No translation file for language "${lang}"`));
        }
        return from(loadFile()).pipe(map((file) => file.default));
    }
}
